import ACTION_TYPES from '../../constants/actionTypes';

/*
 * Toast
 * ========================================
 */

function _showToast(options) {
  return {
    type: ACTION_TYPES.SHOW_TOAST,
    style: options.style,
    message: options.message,
  };
}

export function showToast(message, style = 'default') {
  return dispatch => {
    dispatch(
      _showToast({
        style,
        message,
      })
    );
  };
}

export function hideToast() {
  return {
    type: ACTION_TYPES.HIDE_TOAST,
  };
}

/*
 * Menu
 * ========================================
 */

export function showMenu() {
  // Disable scrolling
  document.body.style.overflow = 'hidden';
  document.body.style.height = '100%';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  return {
    type: ACTION_TYPES.SHOW_MENU,
  };
}

export function hideMenu() {
  // Enable scrolling
  document.body.style.overflow = 'auto';
  document.body.style.height = 'auto';
  document.body.style.position = 'relative';
  document.body.style.width = 'auto';
  return {
    type: ACTION_TYPES.HIDE_MENU,
  };
}

/*
 * Modals
 * ========================================
 */

export function showGlobalModal({ id, ...rest }) {
  return {
    type: ACTION_TYPES.SHOW_GLOBAL_MODAL,
    payload: {
      id,
      ...rest,
    },
  };
}

export function hideGlobalModal() {
  return {
    type: ACTION_TYPES.HIDE_GLOBAL_MODAL,
  };
}
